import { render, staticRenderFns } from "./DropdownDateHistory.vue?vue&type=template&id=23468e78&scoped=true&"
import script from "./DropdownDateHistory.vue?vue&type=script&lang=js&"
export * from "./DropdownDateHistory.vue?vue&type=script&lang=js&"
import style0 from "./DropdownDateHistory.vue?vue&type=style&index=0&id=23468e78&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23468e78",
  null
  
)

export default component.exports